import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9c54bd8a")

_pushScopeId("data-v-9c54bd8a")
const _hoisted_1 = { class: "eoi-review" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 content_main_wrap" }
const _hoisted_5 = { class: "content_ls_margin" }
const _hoisted_6 = { class: "ls-slate-light" }
const _hoisted_7 = { class: "content_ls_margin" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "fal fa-angle-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_HeaderStepper = _resolveComponent("HeaderStepper")
  const _component_Review = _resolveComponent("Review")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (_ctx.isLoadingData)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_HeaderStepper, {
      navSteps: [],
      navbarText: _ctx.navbarText
    }, null, 8, ["navbarText"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, [
              _createVNode("b", null, _toDisplayString(_ctx.pageTitle) + " " + _toDisplayString(_ctx.committeeYear), 1)
            ])
          ]),
          _createVNode(_component_Review, {
            eoi: _ctx.eoiForm,
            "onUpdate:eoi": _cache[1] || (_cache[1] = $event => (_ctx.eoiForm = $event)),
            isReviewing: true
          }, null, 8, ["eoi"]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              (_ctx.backButtonVisible)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn btn-tertiary",
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.backButton()))
                  }, _toDisplayString(_ctx.backButtonText), 1))
                : _createCommentVNode("", true),
              _createVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.eoiApply()))
              }, [
                _createTextVNode(_toDisplayString(_ctx.nextButtonText) + " ", 1),
                _hoisted_9
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
})